import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Toast from '@/components/Toast';
import useSuperAdminData from '@/hooks/useSuperAdminData';
import SuperAdminTabs from '@/components/admin/SuperAdminTabs';
import SuperAdminTabContent from '@/components/admin/SuperAdminTabContent';

export default function SuperAdmin() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('dashboard');
  const [toast, setToast] = useState(null);
  const [orderFilters, setOrderFilters] = useState({
    status: '', paymentMethod: '', project: '', dateFrom: '', dateTo: '', search: '',
  });

  const data = useSuperAdminData(activeTab, orderFilters);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/login');
  };

  return (
    <div className="min-h-screen bg-gray-50" data-testid="superadmin-page">
      <div className="border-b" style={{ backgroundColor: '#051C2C' }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">
            <div className="flex items-center gap-4">
              <img src="/logos/caura-pay-main.png" alt="Caura Pay" className="h-12" />
              <div className="border-l border-white/30 pl-4">
                <h1 className="text-xl font-bold text-white">Super Admin Panel</h1>
                <p className="text-sm text-gray-300">Panel de Administracion Global</p>
              </div>
            </div>
            <button
              data-testid="superadmin-logout"
              onClick={handleLogout}
              className="px-4 py-2 text-white border border-white/30 rounded-lg hover:bg-white/10"
            >
              Cerrar Sesion
            </button>
          </div>
        </div>
      </div>

      <SuperAdminTabs activeTab={activeTab} setActiveTab={setActiveTab} />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {data.loading ? (
          <div className="text-center py-12" data-testid="superadmin-loading">Cargando...</div>
        ) : (
          <SuperAdminTabContent
            activeTab={activeTab}
            data={data}
            orderFilters={orderFilters}
            setOrderFilters={setOrderFilters}
            setToast={setToast}
          />
        )}
      </div>

      {toast && <Toast message={toast.message} type={toast.type} onClose={() => setToast(null)} />}
    </div>
  );
}
